import React, { Component } from 'react';

// function preventTouchMove (e) {
// 	e.preventDefault();
// };
//
// function allowTouchMove (e) {
// 	e.stopPropagation();
// };
//
// function preventInertiaScroll () {
// 	var top = this.scrollTop;
// 	var totalScroll = this.scrollHeight;
// 	var currentScroll = top + this.offsetHeight;
//
// 	if (top === 0) {
// 		this.scrollTop = 1;
// 	} else if (currentScroll === totalScroll) {
// 		this.scrollTop = top - 1;
// 	}
// }

class ScrollLock extends Component {
  componentDidMount() {
    window.addEventListener('wheel', this.onScrollHandler, false);
    // this.scrollingElement.addEventListener('touchmove', preventTouchMove, false); // 2.
    // this.scrollingElement.addEventListener('touchstart', preventInertiaScroll, false); // 3.
    // this.scrollingElement.addEventListener('touchmove', allowTouchMove, false); // 3.
  }

  componentWillUnmount() {
    window.removeEventListener('wheel', this.onScrollHandler, false);
    // this.scrollingElement.removeEventListener('touchmove', preventTouchMove, false);
    // this.scrollingElement.removeEventListener('touchstart', preventInertiaScroll, false);
    // this.scrollingElement.removeEventListener('touchmove', allowTouchMove, false);
  }

  setScrollingElement = (r) => {
    this.scrollingElement = r ? r.firstChild : r;
  };

  onScrollHandler = (e) => {
    const elem = this.scrollingElement;
    const { scrollTop, scrollHeight, clientHeight } = elem;
    const wheelDelta = e.deltaY;
    const isDeltaPositive = wheelDelta > 0;

    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
      elem.scrollTop = scrollHeight;
      return this.cancelScrollEvent(e);
    }
    else {
      if (!e.path.includes(this.scrollingElement)) {
        return this.cancelScrollEvent(e);
      } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
        elem.scrollTop = 0;
        return this.cancelScrollEvent(e);
      }
    }
  };

  cancelScrollEvent = (e) => {
    e.stopImmediatePropagation();
    e.preventDefault();
    e.returnValue = false;
    return false;
  };

  render() {
    return (
      <div ref={this.setScrollingElement}>
        {this.props.children}
      </div>
    );
  }
}

export default ScrollLock;



// WEBPACK FOOTER //
// ./src/components/ScrollLock.js